// extracted by mini-css-extract-plugin
module.exports = {"status":"StatusCell_status__2CPUU","active":"StatusCell_active__-bg47","inactive":"StatusCell_inactive__2BEXh"};